import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Message, {
      severity: _ctx.anomalySeverity,
      closable: false
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.anomalyDescription), 1)
      ]),
      _: 1
    }, 8, ["severity"])
  ]))
}